export const PROFILE_REQUEST = "PROFILE_REQUEST";
export const PROFILE_RECEIVE = "PROFILE_RECEIVE";
export const PROFILE_UPDATE = "PROFILE_UPDATE";
export const PROFILE_CHANGING_PASSWORD = "PROFILE_CHANGING_PASSWORD";
export const PROFILE_CHANGING_PASSWORD_ERROR = "PROFILE_CHANGING_PASSWORD_ERROR";
export const PROFILE_CHANGED_PASSWORD = "PROFILE_CHANGED_PASSWORD";
export const PROFILE_CLEAN_ON_LOGOUT = "PROFILE_CLEAN_ON_LOGOUT";
